const initialState = {
  promotionExpired: false,
}

const onboarding = (state = initialState, action) => {
  switch (action.type) {
    case 'ONBOARDING.PROMOTION_EXPIRED':
      return {
        ...state,
        promotionExpired: true,
      }
    default:
      return state
  }
}

export default onboarding
